import { useLastLoadedOrders } from "api/wms/hooks";
import styles from "../../Dashboard.module.css";
import { LastLoadedOrder } from "api/wms/models";
import { comfortableListUiSchema } from "components/miloDesignSystem/molecules/table/uiSchemas";
import { Table } from "components/miloDesignSystem/molecules/table";
import { useSearch } from "../../shared/useSearch";
import { useLastLoadedOrdersColumns } from "./useLastLoadedOrdersColumns";
import { Typography } from "components/miloDesignSystem/atoms/typography";

export const LastLoadedOrdersList = () => {
  const search = useSearch();
  const { data: lastLoaded, error, isPreviousData, isLoading } = useLastLoadedOrders(search);
  const columns = useLastLoadedOrdersColumns();

  return (
    <div className={styles.card}>
      <div>
        <div className="d-flex align-items-center justify-content-between gap-1 px-3 py-3">
          <Typography className={styles.sectionTitle} fontSize="16" fontWeight="700">
            Ostatnio załadowane zamówienia
          </Typography>
        </div>
        <div className="d-flex flex-1 overflow-hidden justify-content-between">
          <Table<LastLoadedOrder>
            rows={lastLoaded}
            columns={columns}
            isLoading={isLoading || isPreviousData}
            error={error}
            uiSchema={comfortableListUiSchema}
          />
        </div>
      </div>
    </div>
  );
};
